import React, { useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Box,
  Snackbar,
} from "@mui/material";
import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";

const AddYoutubeVideo = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    title: "",
    youtubeVideoId: "",
    description: "",
    language: "en",
    sortOrder: 0,
  });

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title || !formData.youtubeVideoId) {
      setError("Title and YouTube Video ID are required.");
      return;
    }

    try {
      const response = await fetch(`${API_URL}/v1/youtube-videos`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          sortOrder: Number(formData.sortOrder || 0),
        }),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setSuccess("YouTube video added successfully.");

        setFormData({
          title: "",
          youtubeVideoId: "",
          description: "",
          language: "en",
          sortOrder: 0,
        });
      } else {
        setError(result.error || "Failed to add video.");
      }
    } catch (err) {
      console.error(err);
      setError("Server error.");
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Add YouTube Video
      </Typography>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              label="Title"
              name="title"
              fullWidth
              required
              value={formData.title}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="YouTube Video ID"
              name="youtubeVideoId"
              fullWidth
              required
              helperText="Example: dQw4w9WgXcQ"
              value={formData.youtubeVideoId}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Description"
              name="description"
              fullWidth
              multiline
              rows={4}
              value={formData.description}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Language"
              name="language"
              fullWidth
              value={formData.language}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Sort Order"
              name="sortOrder"
              type="number"
              fullWidth
              value={formData.sortOrder}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              startIcon={<CloudUploadIcon />}
            >
              Add Video
            </Button>
          </Grid>
        </Grid>
      </form>

      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={() => setError(null)}
        message={error}
      />

      <Snackbar
        open={!!success}
        autoHideDuration={6000}
        onClose={() => setSuccess(null)}
        message={success}
      />
    </Box>
  );
};

export default AddYoutubeVideo;